import ChildrenCategoriesTypeEnum from 'Rentlio/utils/childrenCategoriesEnum'

export const getNumberOfChildrenTreatedAsAdults = childrenCategories => {
  if (!childrenCategories || childrenCategories.length === 0) {
    return 0
  }

  return childrenCategories.filter(category => +category.type === ChildrenCategoriesTypeEnum.AS_ADULT).length
}
